import { CrudEndpoint } from '@/api/common/CrudEndpoint';
import { PreorderProductDTO } from '@/api/dto/PreorderProductDTO';

export class PreorderProductCRUD extends CrudEndpoint<PreorderProductDTO> {
  constructor() {
    super('preorderproduct');
  }
}
